import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Typography } from './Typography';

export interface LetterRoundelProps {
  letter: string;
}

const StyledLetterRoundel = styled(Typography)`
  ${({ theme: { space, colors } }) => css`
    display: grid;
    place-items: center;
    color: ${colors.white.default};
    background-color: ${colors.black.default};
    text-transform: uppercase;
    border-radius: 50%;
    width: 24px;
    height: 24px;
  `};
`;

export const LetterRoundel: FC<LetterRoundelProps> = ({ letter, ...rest }) => (
  <StyledLetterRoundel component="span" variant="titleExtraSmall" {...rest}>
    {letter}
  </StyledLetterRoundel>
);
